var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleCloudLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 41,
    viewBox: "0 0 50 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6511 11.1738L33.243 11.2036L37.57 6.87654L37.7809 5.04411C34.343 1.98466 29.8187 0.122498 24.8647 0.122498C15.8944 0.122498 8.32954 6.22249 6.0863 14.4928C6.55928 14.1657 7.56738 14.409 7.56738 14.409L16.216 12.9873C16.216 12.9873 16.6647 12.2522 16.8836 12.2982C18.862 10.1333 21.7079 8.77114 24.8647 8.77114C27.4322 8.77114 29.7944 9.67384 31.6511 11.1738Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6487 14.5036C42.646 10.7955 40.5703 7.52522 37.7784 5.04144L31.6487 11.1712C34.1027 13.1549 35.6757 16.1874 35.6757 19.582V20.663C38.6568 20.663 41.0811 23.0874 41.0811 26.0684C41.0811 29.0495 38.6568 31.4738 35.6757 31.4738H24.8649L23.7838 32.5603V39.0468L24.8649 40.1225H35.6757C43.4243 40.1225 49.7297 33.8171 49.7297 26.0684C49.7297 21.2766 47.3189 17.0414 43.6487 14.5036Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.054 40.1225H24.8567V31.4739H14.054C13.2594 31.4739 12.5081 31.2982 11.827 30.9874L10.2702 31.4657L5.94051 35.7955L5.56213 37.2576C7.92159 39.0522 10.8648 40.1225 14.054 40.1225Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.054 12.0144C6.3054 12.0144 0 18.3198 0 26.0684C0 30.6306 2.18648 34.6928 5.56756 37.2603L11.8351 30.9928C9.95945 30.1441 8.64864 28.2576 8.64864 26.0684C8.64864 23.0874 11.073 20.663 14.054 20.663C16.2432 20.663 18.1297 21.9739 18.9784 23.8495L25.2459 17.582C22.6784 14.2009 18.6162 12.0144 14.054 12.0144Z",
    fill: "#FBBC05"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloudLogo);
export default __webpack_public_path__ + "static/media/google-cloud-logo.c4223b78fe754f2cc6dba54f8bb835d8.svg";
export { ForwardRef as ReactComponent };